$(document).ready(function(){
    
    const com1 = {
        name: $('#com1-name').val(),
        movement: $('#com1-move').val(),
        attkDice: $('#com1-attk').val(),
        tmpAttk: 0,
        defDice: $('#com1-def').val(),
        tmpDef: 0,
        bp: $('#com1-bp').val(),
        mp: $('#com1-mp').val(),
        isHero: true,
        missTurns: 0,
        asleep: false,
        spells: {
            fbof: $('#com1-fbof').is(':checked'),
            fc: $('#com1-fc').is(':checked'),
            ffow: $('#com1-ffow').is(':checked'),
            ag: $('#com1-ag').is(':checked'),
            at: $('#com1-at').is(':checked'),
        },
    };
    const com2 = {
        name: $('#com2-name').val(),
        movement: $('#com2-move').val(),
        attkDice: $('#com2-attk').val(),
        tmpAttk: 0,
        defDice: $('#com2-def').val(),
        tmpDef: 0,
        bp: $('#com2-bp').val(),
        mp: $('#com2-mp').val(),
        isHero: false,
        missTurns: 0,
        asleep: false,
        spells: {
            fbof: $('#com2-fbof').is(':checked'),
            fc: $('#com2-fc').is(':checked'),
            ffow: $('#com2-ffow').is(':checked'),
            ag: $('#com2-ag').is(':checked'),
            at: $('#com2-at').is(':checked'),
        },
    };

    const com1Base = {
        name: $('#com1-name').val(),
        movement: $('#com1-move').val(),
        attkDice: $('#com1-attk').val(),
        tmpAttk: 0,
        defDice: $('#com1-def').val(),
        tmpDef: 0,
        bp: $('#com1-bp').val(),
        mp: $('#com1-mp').val(),
        isHero: $('#com1-ishero').is(':checked'),
        missTurns: 0,
        asleep: false,
        spells: {
            fbof: $('#com1-fbof').is(':checked'),
            fc: $('#com1-fc').is(':checked'),
            ffow: $('#com1-ffow').is(':checked'),
            ag: $('#com1-ag').is(':checked'),
            at: $('#com1-at').is(':checked'),
        },
    };
    const com2Base = {
        name: $('#com2-name').val(),
        movement: $('#com2-move').val(),
        attkDice: $('#com2-attk').val(),
        tmpAttk: 0,
        defDice: $('#com2-def').val(),
        tmpDef: 0,
        bp: $('#com2-bp').val(),
        mp: $('#com2-mp').val(),
        isHero: $('#com2-ishero').is(':checked'),
        missTurns: 0,
        asleep: false,
        spells: {
            fbof: $('#com2-fbof').is(':checked'),
            fc: $('#com2-fc').is(':checked'),
            ffow: $('#com2-ffow').is(':checked'),
            ag: $('#com2-ag').is(':checked'),
            at: $('#com2-at').is(':checked'),
        },
    };

    function resetCombatants(){
        com1.name = $('#com1-name').val();
        com1.movement = $('#com1-move').val();
        com1.attkDice = $('#com1-attk').val();
        com1.tmpAttk = 0;
        com1.tmpDef = 0;
        com1.defDice = $('#com1-def').val();
        com1.bp = $('#com1-bp').val();
        com1.mp = $('#com1-mp').val();
        com1.isHero = $('#com1-ishero').is(':checked');
        com1.missTurns = 0;
        com1.asleep = false;
        
        com1.spells.fbof = $('#com1-fbof').is(':checked');
        com1.spells.fc = $('#com1-fc').is(':checked');
        com1.spells.ffow = $('#com1-ffow').is(':checked');
        com1.spells.ag = $('#com1-ag').is(':checked');
        com1.spells.at = $('#com1-at').is(':checked');

        com2.name = $('#com2-name').val();
        com2.movement = $('#com2-move').val();
        com2.attkDice = $('#com2-attk').val();
        com2.tmpAttk = 0;
        com2.tmpDef = 0;
        com2.defDice = $('#com2-def').val();
        com2.bp = $('#com2-bp').val();
        com2.mp = $('#com2-mp').val();
        com2.isHero = $('#com2-ishero').is(':checked');
        com2.missTurns = 0;
        com2.asleep = false;

        com2.spells.fbof = $('#com2-fbof').is(':checked');
        com2.spells.fc = $('#com2-fc').is(':checked');
        com2.spells.ffow = $('#com2-ffow').is(':checked');
        com2.spells.ag = $('#com2-ag').is(':checked');
        com2.spells.at = $('#com2-at').is(':checked');
    }

    //aggregate test data
    var data = [];
    data['turns'] = [];
    data['com1BPlost'] = [];
    data['com2BPlost'] = [];
    data['com1Defeats'] = [];
    data['com2Defeats'] = [];

    //Dice roller function
    function diceRoller(d, s = null){
        var sides = ["sk","sk","sk","ws","ws","bs"];
        var result = [];
        result['sk'] = 0, result['ws'] = 0, result['bs'] = 0;

        for(let i =0; i<d; i++)
            result[sides[Math.floor(Math.random()*6)]]++;

        //console.log(result);
        if(s != null)
            return result[s];
        return result;
    }

    //log to the onscreen console
    function log(t){
        var theconsole = $("#console");
        theconsole.append('<p>'+t+'</p>');

        // var theconsole = $("#console");
        // if(theconsole.val() == "")
        //     theconsole.val(t);
        // else
        //     theconsole.val($("#console").val() + "\n" + t);
         theconsole.scrollTop(theconsole[0].scrollHeight - theconsole.height());
    }
    
    function rlog(t){
        var theconsole = $("#result");
        if(theconsole.val() == "")
            theconsole.val(t);
        else
            theconsole.val($("#result").val() + "\n" + t);
        
        //theconsole.append('<p>'+t+'</p>');
        theconsole.scrollTop(theconsole[0].scrollHeight - theconsole.height());
    }

    function runTest(i = 100, n = 1){
        if(i == 0){
            //log results from test
            var turnData = data['turns'];
            var turnTotal = 0;
            var turnAvg = 0;
            var c1bpData = data['com1BPlost'];
            var c1bpTotal = 0;
            var c2bpTotal = 0;
            var c2bpData = data['com2BPlost'];
            var c2bpAvg = 0;
            var c1bpAvg = 0;

            //get average number of turns
            for(i = 0; i < turnData.length; i++){
                turnTotal = turnTotal + turnData[i];
            }
            turnAvg = turnTotal / turnData.length;

            //get average bp losses
            for(i = 0; i < c1bpData.length; i++){
                c1bpTotal = c1bpTotal + c1bpData[i];
            }
            c1bpAvg = c1bpTotal / c1bpData.length;
            for(i = 0; i < c2bpData.length; i++){
                c2bpTotal = c2bpTotal + c2bpData[i];
            }
            c2bpAvg = c2bpTotal / c2bpData.length;

            //output data to result console
            var avgTurnsLabel = 'Avg Turns';
            var c1DefeatsLabel = com1.name + ' Defeated';
            var c2DefeatsLabel = com2.name + ' Defeated';
            var c1BPlostLabel = com1.name + ' Avg BP Lost';
            var c2BPlostLabel = com2.name + ' Avg BP Lost';

            var avgTurnsData = turnAvg.toString();
            var c1DefeatsData = data['com1Defeats'].toString();
            var c2DefeatsData = data['com2Defeats'].toString();
            var c1BPlostData = c1bpAvg.toString();
            var c2BPlostData = c2bpAvg.toString();

            if($('#format-text').is(':checked')){
                rlog(avgTurnsLabel.padEnd(avgTurnsLabel.length + 3) + c1DefeatsLabel.padEnd(c1DefeatsLabel.length + 3) + c2DefeatsLabel.padEnd(c2DefeatsLabel.length + 3) + c1BPlostLabel.padEnd(c1BPlostLabel.length + 3) + c2BPlostLabel);
                rlog(avgTurnsData.padEnd(avgTurnsLabel.length + 3) + c1DefeatsData.padEnd(c1DefeatsLabel.length + 3) + c2DefeatsData.padEnd(c2DefeatsLabel.length + 3) + c1BPlostData.padEnd(c1BPlostLabel.length + 3) + c2BPlostData);
            }else if($('#format-csv').is(':checked')){
                $('#result').css('white-space', 'normal');
                rlog(avgTurnsLabel + ',' + c1DefeatsLabel + ',' + c2DefeatsLabel + ',' + c1BPlostLabel + ',' + c2BPlostLabel);
                rlog(avgTurnsData + ',' + c1DefeatsData + ',' + c2DefeatsData + ',' + c1BPlostData + ',' + c2BPlostData);
            }else if($('#format-tsv').is(':checked')){
                rlog(avgTurnsLabel + '\t' + c1DefeatsLabel + '\t' + c2DefeatsLabel + '\t' + c1BPlostLabel + '\t' + c2BPlostLabel);
                rlog(avgTurnsData + '\t' + c1DefeatsData + '\t' + c2DefeatsData + '\t' + c1BPlostData + '\t' + c2BPlostData);
            }

            //Set everything to readonly
            $('input').prop('disabled', '');
            $('select').prop('disabled', '');
            $('button').prop('disabled', '');

            return;
        }
        
        var attk;
        var def;
        var damage;
        var check = '';

        //run through the iteration
        //get combatant data
        resetCombatants();
        log("ENCOUNTER ITERATION: " + n);
        log("--------------------------------------------------------------");

        //attack eachother as long as no one has 0 bp
        var turns = 0;
        var attacker = com1;
        var defender = com2;
        while(attacker.bp > 0 && defender.bp > 0){
            turns++;
            var usedSpell = false;

            //check through all the spells
            if(attacker.spells.fbof && !usedSpell){
                usedSpell = true;
                //roll 5 or 6 for no damage same odds as ws
                roll = diceRoller(2, 'ws');
                var damage = 2 - roll;
                defender.bp = (damage >= defender.bp) ? 0 : defender.bp - damage;
                log(attacker.name + " used 'Ball of Flame' VS " + defender.name + " for " + damage + " BP | " + defender.name + " BP: " + defender.bp);
                //mark spell used
                attacker.spells.fbof = false;
            }
            if(attacker.spells.fc && !usedSpell){
                usedSpell = true;
                //2 extra attack dice
                var ad = attacker.attkDice;
                attacker.attkDice = 2 + parseInt(attacker.attkDice);
                log(attacker.name + " used 'Courage' and now attacks with " + attacker.attkDice + " instead of " + ad);
                //mark spell used
                attacker.spells.fc = false;
            }
            if(attacker.spells.ffow && !usedSpell){
                usedSpell = true;
                //roll 5 or 6 for no damage same odds as ws
                roll = diceRoller(1, 'ws');
                var damage = 1 - roll;
                defender.bp = (damage >= defender.bp) ? 0 : defender.bp - damage;
                log(attacker.name + " used 'Fire of Wrath' VS " + defender.name + " for " + damage + " BP | " + defender.name + " BP: " + defender.bp);
                //mark spell used
                attacker.spells.ffow = false;
            }
            if(attacker.spells.ag && !usedSpell){
                //usedSpell = true;
                //attack with 5 combat dice
                attacker.tmpAttk = 5;
                log(attacker.name + " used 'Genie' and now attacks with 5 instead of " + attacker.attkDice + " for this turn");
                //mark spell used
                attacker.spells.ag = false;
            }
            if(attacker.spells.at && !usedSpell){
                usedSpell = true;
                //tempest, next combatant misses turn
                defender.missTurns = 1;
                log(attacker.name + " used 'Tempest' VS " + defender.name + ", " + defender.name + " misses next turn");
                //mark spell used
                attacker.spells.at = false;
            }

            if(!usedSpell && attacker.missTurns == 0){
                //combatant 1 attacks first
                if(attacker.tmpAttk != 0){
                    attk = diceRoller(attacker.tmpAttk, 'sk');
                    attacker.tmpAttk = 0;
                }
                else
                    attk = diceRoller(attacker.attkDice, 'sk');
                check = "";
                
                //combatant 2 defends
                //if c1 rolled more skulls than c2 def dice, check if defeated
                //log(attk + ' v ' + com2.def + ((attk > com2.def)?" attk bigger": " def bigger"));
                if(attk > defender.defDice){
                    damage = attk - defender.defDice;
                    if(damage >= defender.bp){
                        defender.bp = 0;
                        def = '--';
                    }
                    else{
                    //c2 defend
                        check = (defender.isHero) ? 'ws': 'bs';
                        def = diceRoller(defender.defDice, check);
                        //lose bp if needed
                        damage = attk - def;
                        defender.bp = (damage >= defender.bp) ? 0: (damage <= 0) ? defender.bp : defender.bp - damage; 
                    }
                }
                else if(attk == 0){
                    def = '--';
                }
                else{
                    //c2 defend
                    check = (defender.isHero) ? 'ws': 'bs';
                    def = diceRoller(defender.defDice, check);
                    //lose bp if needed
                    damage = attk - def;
                    defender.bp = (damage >= defender.bp) ? 0: (damage <= 0) ? defender.bp : defender.bp - damage;
                }

                log(attacker.name + " Roll: " + attk + " Skull(s) VS " + defender.name + " Roll: " + def + " " + ((check == "ws")?"White Shield(s)":(check == "bs") ? "Black Shield(s)" : "") + " | " + defender.name + " BP: " + defender.bp);
            }else if(attacker.missTurns > 0){
                attacker.missTurns = attacker.missTurns - 1;
                log(attacker.name + " missed their turn");
            }

            //switch attacker with defender
            var tmpa = attacker;
            attacker = defender;
            defender = tmpa;
        }
        
        
        //display iteration results
        var com1BPlost = (com1Base.bp - com1.bp);
        var com2BPlost = (com2Base.bp - com2.bp);
        var defeated;
        if(com1.bp == 0)
            defeated = com1.name;
        else if(com2.bp == 0)
            defeated = com2.name;
        
        log("--------------------------------------------------------------");
        log("RESULT( Turns: " + turns + " | " + com1.name + " BP Lost: " + com1BPlost + " | " + com2.name + " BP Lost: " + com2BPlost + " | " + defeated + " Defeated )");
        log("==============================================================");

        //log aggregate data
        data['turns'].push(turns);
        data['com1BPlost'].push(com1BPlost);
        data['com2BPlost'].push(com2BPlost);
        if(com1.bp == 0)
            data['com1Defeats'] = data['com1Defeats'] + 1;
        else if(com2.bp == 0)
            data['com2Defeats'] = data['com2Defeats'] + 1;

        setTimeout(function(){
            runTest(i-1, n+1);
        }, 0);
    }

    //runs the test
    $('#run-test').bind('click', function(){
        //cleanup
        resetCombatants();
        $('#console').html('');

        //Set everything to readonly
        $('input').prop('disabled', 'disabled');
        $('select').prop('disabled', 'disabled');
        $('button').prop('disabled', 'disabled');

        //reset aggregate test data
        data['turns'] = [];
        data['com1BPlost'] = [];
        data['com2BPlost'] = [];
        data['com1Defeats'] = 0;
        data['com2Defeats'] = 0;

        //run the test
        runTest($('#iterations').val());
    });

    //change values for combatants when select changed
    var template = [];
    template['Barbarian'] = {
        movement: '--',
        attkDice: 3,
        defDice: 2,
        bp: 8,
        mp: 2,
        isHero: true
    }
    template['Dwarf'] = {
        movement: '--',
        attkDice: 2,
        defDice: 2,
        bp: 7,
        mp: 3,
        isHero: true
    }
    template['Elf'] = {
        movement: '--',
        attkDice: 2,
        defDice: 2,
        bp: 6,
        mp: 4,
        isHero: true
    }
    template['Wizard'] = {
        movement: '--',
        attkDice: 1,
        defDice: 2,
        bp: 4,
        mp: 6,
        isHero: true
    }
    template['Goblin'] = {
        movement: 10,
        attkDice: 2,
        defDice: 1,
        bp: 1,
        mp: 1,
        isHero: false
    }
    template['Skeleton'] = {
        movement: 6,
        attkDice: 2,
        defDice: 2,
        bp: 1,
        mp: 0,
        isHero: false
    }
    template['Zombie'] = {
        movement: 5,
        attkDice: 2,
        defDice: 3,
        bp: 1,
        mp: 0,
        isHero: false
    }
    template['Orc'] = {
        movement: 8,
        attkDice: 2,
        defDice: 3,
        bp: 1,
        mp: 2,
        isHero: false
    }
    template['Fimir'] = {
        movement: 6,
        attkDice: 3,
        defDice: 3,
        bp: 2,
        mp: 3,
        isHero: false
    }
    template['Mummy'] = {
        movement: 4,
        attkDice: 2,
        defDice: 4,
        bp: 2,
        mp: 0,
        isHero: false
    }
    template['Chaos Warrior'] = {
        movement: 7,
        attkDice: 4,
        defDice: 4,
        bp: 3,
        mp: 3,
        isHero: false
    }
    template['Gargoyle'] = {
        movement: 6,
        attkDice: 4,
        defDice: 5,
        bp: 3,
        mp: 4,
        isHero: false
    }
    template['Sir Ragnar'] = {
        movement: '--',
        attkDice: 0,
        defDice: 2,
        bp: 2,
        mp: '--',
        isHero: true
    }
    template['Ulag'] = {
        movement: 10,
        attkDice: 2,
        defDice: 5,
        bp: 2,
        mp: 3,
        isHero: false
    }
    template['Grak'] = {
        movement: 8,
        attkDice: 4,
        defDice: 4,
        bp: 3,
        mp: 3,
        isHero: false
    }
    template['Balur'] = {
        movement: 8,
        attkDice: 2,
        defDice: 5,
        bp: 3,
        mp: 7,
        isHero: false
    }
    template['Witch Lord'] = {
        movement: 10,
        attkDice: 5,
        defDice: 6,
        bp: 4,
        mp: 6,
        isHero: false
    }
    template['Enchanted Suit of Armor'] = {
        movement: 7,
        attkDice: 4,
        defDice: 4,
        bp: 3,
        mp: 3,
        isHero: false
    }
    template['Undead Ancient Dwarven King'] = {
        movement: 6,
        attkDice: 3,
        defDice: 4,
        bp: 2,
        mp: 0,
        isHero: false
    }
    template['Gragor'] = {
        movement: 7,
        attkDice: 4,
        defDice: 4,
        bp: 3,
        mp: 3,
        isHero: false
    }
    template['Ograk'] = {
        movement: 7,
        attkDice: 4,
        defDice: 4,
        bp: 3,
        mp: 3,
        isHero: false
    }
    template['Borokk'] = {
        movement: 7,
        attkDice: 4,
        defDice: 4,
        bp: 3,
        mp: 3,
        isHero: false
    }
    template['Guardian of Grin\'s Crag'] = {
        movement: 6,
        attkDice: 4,
        defDice: 5,
        bp: 4,
        mp: 4,
        isHero: false
    }
    template['Spirit Rider'] = {
        movement: 8,
        attkDice: 4,
        defDice: 4,
        bp: 3,
        mp: 3,
        isHero: false
    }
    template['Bellthor'] = {
        movement: 6,
        attkDice: 4,
        defDice: 6,
        bp: 3,
        mp: 3,
        isHero: false
    }
    template['Skulmar'] = {
        movement: 8,
        attkDice: 5,
        defDice: 6,
        bp: 3,
        mp: 4,
        isHero: false
    }
    template['Doomguard'] = {
        movement: 8,
        attkDice: 4,
        defDice: 6,
        bp: 3,
        mp: 3,
        isHero: false
    }
    template['Kessandria, the Witch Queen'] = {
        movement: 6,
        attkDice: 4,
        defDice: 6,
        bp: 3,
        mp: 4,
        isHero: false
    }
    template['The Witch Lord'] = {
        movement: 10,
        attkDice: 5,
        defDice: 6,
        bp: 4,
        mp: 5,
        isHero: false
    }
    template['The Crossbowman'] = {
        movement: 6,
        attkDice: 3,
        defDice: 3,
        bp: 2,
        mp: 2,
        isHero: true
    }
    template['The Halberdier'] = {
        movement: 6,
        attkDice: 3,
        defDice: 3,
        bp: 2,
        mp: 2,
        isHero: true
    }
    template['The Swordsman'] = {
        movement: 5,
        attkDice: 4,
        defDice: 5,
        bp: 2,
        mp: 2,
        isHero: true
    }
    template['The Scout'] = {
        movement: 9,
        attkDice: 2,
        defDice: 3,
        bp: 2,
        mp: 2,
        isHero: true
    }
    template['Ice Gremlin'] = {
        movement: 10,
        attkDice: 2,
        defDice: 3,
        bp: 3,
        mp: 3,
        isHero: false
    }
    template['Polar Warbear'] = {
        movement: 6,
        attkDice: 4,
        defDice: 3,
        bp: 6,
        mp: 2,
        isHero: false
    }
    template['Yeti'] = {
        movement: 8,
        attkDice: 3,
        defDice: 3,
        bp: 5,
        mp: 2,
        isHero: false
    }
    template['Frozen Horror'] = {
        movement: 8,
        attkDice: 5,
        defDice: 4,
        bp: 6,
        mp: 4,
        isHero: false
    }
    template['Krag'] = {
        movement: 7,
        attkDice: 5,
        defDice: 5,
        bp: 4,
        mp: 3,
        isHero: false
    }
    template['Gothar'] = {
        movement: 6,
        attkDice: 1,
        defDice: 2,
        bp: 2,
        mp: 4,
        isHero: true
    }
    template['Vilor'] = {
        movement: 8,
        attkDice: 4,
        defDice: 3,
        bp: 4,
        mp: 5,
        isHero: false
    }
    template['Undead Barbarian Hero Kelvinos'] = {
        movement: 8,
        attkDice: 4,
        defDice: 4,
        bp: 4,
        mp: 0,
        isHero: false
    }
    template['Elven Archer'] = {
        movement: 6,
        attkDice: 4,
        defDice: 2,
        bp: 3,
        mp: 2,
        isHero: false
    }
    template['Elven Warrior'] = {
        movement: 6,
        attkDice: 4,
        defDice: 3,
        bp: 3,
        mp: 2,
        isHero: false
    }
    template['Giant Wolf'] = {
        movement: 9,
        attkDice: 6,
        defDice: 3,
        bp: 5,
        mp: 1,
        isHero: false
    }
    template['Ogre'] = {
        movement: 4,
        attkDice: 6,
        defDice: 4,
        bp: 10,
        mp: 2,
        isHero: false
    }
    template['The High Alchemist'] = {
        movement: 8,
        attkDice: 3,
        defDice: 3,
        bp: 4,
        mp: 4,
        isHero: false
    }
    template['Tormuk'] = {
        movement: 8,
        attkDice: 4,
        defDice: 4,
        bp: 6,
        mp: 6,
        isHero: false
    }
    template['Sinestra'] = {
        movement: 8,
        attkDice: 4,
        defDice: 4,
        bp: 4,
        mp: 9,
        isHero: false
    }
    template['Warlock'] = {
        movement: '--',
        attkDice: 2,
        defDice: 2,
        bp: 3,
        mp: 5,
        isHero: true
    }
    template['Druid'] = {
        movement: '--',
        attkDice: 1,
        defDice: 2,
        bp: 6,
        mp: 4,
        isHero: true
    }
    template['Bard'] = {
        movement: '--',
        attkDice: 2,
        defDice: 2,
        bp: 5,
        mp: 4,
        isHero: true
    }
    template['Commander of the Guardian Knights'] = {
        movement: '--',
        attkDice: 2,
        defDice: 3,
        bp: 7,
        mp: 2,
        isHero: true
    }
    template['Gor-Lethim Kar'] = {
        movement: 6,
        attkDice: 4,
        defDice: 5,
        bp: 3,
        mp: 4,
        isHero: false
    }
    template['Undead Dread Warrior'] = {
        movement: 7,
        attkDice: 4,
        defDice: 3,
        bp: 3,
        mp: 0,
        isHero: false
    }
    template['The Spirit Queen'] = {
        movement: 7,
        attkDice: 4,
        defDice: 4,
        bp: 6,
        mp: 3,
        isHero: false
    }
    template['Swamp Hag'] = {
        movement: 4,
        attkDice: 2,
        defDice: 3,
        bp: 2,
        mp: 3,
        isHero: false
    }
    template['Giant Undead Horned Minotaur'] = {
        movement: 6,
        attkDice: 3,
        defDice: 3,
        bp: 2,
        mp: 0,
        isHero: false
    }
    template['Goblin Queen Buubhealxea'] = {
        movement: 8,
        attkDice: 3,
        defDice: 3,
        bp: 3,
        mp: 2,
        isHero: false
    }
    template['King Archaloneus'] = {
        movement: 6,
        attkDice: 4,
        defDice: 4,
        bp: 4,
        mp: 3,
        isHero: false
    }
    template['Undead Dwarf'] = {
        movement: 5,
        attkDice: 4,
        defDice: 5,
        bp: 4,
        mp: 0,
        isHero: false
    }
    template['Kerick Gilbane'] = {
        movement: 7,
        attkDice: 5,
        defDice: 5,
        bp: 4,
        mp: 4,
        isHero: false
    }
    template['Venim'] = {
        movement: 9,
        attkDice: 6,
        defDice: 6,
        bp: 5,
        mp: 4,
        isHero: false
    }
    template['Custom'] = {
        movement: '--',
        attkDice: '2',
        defDice: '2',
        bp: '5',
        mp: '5',
        isHero: false
    }

    function changeComVals(com = 'com1', v) {        
        $('#'+com+'-name').val(v);
        $('#'+com+'-move').val(template[v].movement);
        $('#'+com+'-attk').val(template[v].attkDice);
        $('#'+com+'-def').val(template[v].defDice);
        $('#'+com+'-bp').val(template[v].bp);
        $('#'+com+'-mp').val(template[v].mp);
        $('#'+com+'-ishero').prop('checked', template[v].isHero);
        $('#'+com+'-isminion').prop('checked', !template[v].isHero);

        if(com == "com1"){
            com1Base.name = $('#com1-name').val();
            com1Base.movement = $('#com1-move').val();
            com1Base.attkDice = $('#com1-attk').val();
            com1Base.defDice = $('#com1-def').val();
            com1Base.bp = $('#com1-bp').val();
            com1Base.mp = $('#com1-mp').val();
            com1Base.isHero = $('#com1-ishero').is(':checked');
        }else if(com == "com2"){
            com2Base.name = $('#com2-name').val();
            com2Base.movement = $('#com2-move').val();
            com2Base.attkDice = $('#com2-attk').val();
            com2Base.defDice = $('#com2-def').val();
            com2Base.bp = $('#com2-bp').val();
            com2Base.mp = $('#com2-mp').val();
            com2Base.isHero = $('#com2-ishero').is(':checked');
        }
    }

    $('#com1-template').bind('change', function(e){
        changeComVals('com1', this.value);
    });
    $('#com2-template').bind('change', function(e){
        changeComVals('com2', this.value);
    });

    //clear console
    $('#clear-console').bind('click', function(){
        $('#console').html('');
    });

    //clear result
    $('#clear-result').bind('click', function(){
        $('#result').val('');
    });
    
    //reset all
    $('#reset').bind('click', function(){
        //clear console and result
        $('#console').html('');
        $('#result').val('');

        //set combatants to default
        $('#com1-template').val('Barbarian');
        $('#com2-template').val('Orc');
        changeComVals('com1', 'Barbarian');
        changeComVals('com2', 'Orc');

        //set parameters to default
        $('#iterations').val(100);
        $('#format-text').prop('checked', true);
    });

});